export default {
  ESN_OP_WRAPPER_SERVICE: 'op-wrapper-service',
  ESN_GAME_ENGINE: 'game-engine',
  ESN_OP_PRELOADER: 'op-preloader',
}
